import {CanActivate} from '@angular/router';
import {Injectable} from '@angular/core';

import {Observable, of} from 'rxjs';
import {catchError, filter, switchMap, take, tap} from 'rxjs/operators';
import {select, Store} from '@ngrx/store';

import {ApplicationState} from '../../application-state/store';
import {DataRecoveryPriorityModesActions} from '../store';
import {DataRecoveryPriorityModesSelectors} from '../store/selectors';

@Injectable()
export class DataRecoveryPriorityModesLoadedGuard implements CanActivate {

  constructor(private store: Store<ApplicationState>) {
  }

  canActivate(): Observable<boolean> {

    return this.loadDataRecoveryPriorityModesDone().pipe(
      switchMap(() => of(true)),
      catchError(() => of(false))
    );
  }

  loadDataRecoveryPriorityModesDone() {

    return this.store.pipe(
      select(DataRecoveryPriorityModesSelectors.isLoaded),
      tap((loaded: boolean) => {
        if (!loaded) {
          this.store.dispatch(DataRecoveryPriorityModesActions.ReadDataRecoveryPriorityModes());
        }
      }),
      filter(loaded => loaded),
      take(1)
    );
  }
}
